// LocalStorage keys constants
const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh-token',
  USER_ID: 'user_id',
  SWITCH_USER: 'switch_user',
  ADMIN_LINK: 'admin_link',
  SWITCH_USER_ID: 'switch_user_id',
  ORG_ID_ADMIN: 'org-id-admin',
  IS_EDIT_ORGANIZATION: 'is-edit-organization',
  TO_PAGE: 'to_page',
  NO_CROSSELLING: 'no-crosselling',
  EDIT_CONTRACT: 'edit-contract',
  EDIT_CONTRACT_IMMAT: 'edit-contract-immat',
  SHOW_BEFORE_PAYMENT: 'show-before-payment',
  IS_FROM_BV: 'is-from-bv',
  IS_IMMAT_ONLY: 'is-immat-only',
  TUNNEL_DATA: 'tunnel-data',
  SKIP_MY_ACCOUNT: 'skip-my-account',
  CASHBACK_REMINDER: 'cashback-reminder',
} as const;

const AuthService = {
  clearToken: () => localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, ''),
  setAccessToken: (token: string) => localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token),
  getAccessToken: (): string | null => localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN),
  setRefreshToken: (token: string) => localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, token),
  getRefreshToken: (): string | null => localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN),
  removeRefreshToken: () => localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN),
  getUserId: (): string | null => localStorage.getItem(STORAGE_KEYS.USER_ID),
  setUserId: (userId: string) => localStorage.setItem(STORAGE_KEYS.USER_ID, userId),
  getSwitchUser: (): string | null => {
    const switch_user = localStorage.getItem(STORAGE_KEYS.SWITCH_USER);
    return switch_user;
  },
  setSwitchUser: (switchUser: string) => {
    if (!switchUser) {
      AuthService.removeSwitchUserId();
    }

    return localStorage.setItem(STORAGE_KEYS.SWITCH_USER, switchUser);
  },
  getAdminLink: (): string | null => localStorage.getItem(STORAGE_KEYS.ADMIN_LINK),
  setAdminLink: (switchUser: string) => localStorage.setItem(STORAGE_KEYS.ADMIN_LINK, switchUser),
  getSwitchUserId: (): string | null => localStorage.getItem(STORAGE_KEYS.SWITCH_USER_ID),
  setSwitchUserId: (userId: string) => localStorage.setItem(STORAGE_KEYS.SWITCH_USER_ID, userId),
  removeSwitchUserId: () => localStorage.removeItem(STORAGE_KEYS.SWITCH_USER_ID),
  getOrganizationIDByAdmin: (): string | null => localStorage.getItem(STORAGE_KEYS.ORG_ID_ADMIN),
  setOrganizationIDByAdmin: (organizationId: string) =>
    localStorage.setItem(STORAGE_KEYS.ORG_ID_ADMIN, organizationId),
  setIsEditOrganization: (edit: string) =>
    localStorage.setItem(STORAGE_KEYS.IS_EDIT_ORGANIZATION, edit),
  getIsEditOrganization: (): string | null =>
    localStorage.getItem(STORAGE_KEYS.IS_EDIT_ORGANIZATION),
  setToPage: (to: string) => localStorage.setItem(STORAGE_KEYS.TO_PAGE, to),
  getToPage: (): string | null => localStorage.getItem(STORAGE_KEYS.TO_PAGE),
  getNoCrosselling: (): string | null => localStorage.getItem(STORAGE_KEYS.NO_CROSSELLING),
  setNoCrosselling: (value: string) => localStorage.setItem(STORAGE_KEYS.NO_CROSSELLING, value),
  getIsRegenerateContract: (): string | null => localStorage.getItem(STORAGE_KEYS.EDIT_CONTRACT),
  setIsRegenerateContract: (value: string) =>
    localStorage.setItem(STORAGE_KEYS.EDIT_CONTRACT, value),
  getIsRegenerateContractImmat: (): string | null =>
    localStorage.getItem(STORAGE_KEYS.EDIT_CONTRACT_IMMAT),
  setIsRegenerateContractImmat: (value: string) =>
    localStorage.setItem(STORAGE_KEYS.EDIT_CONTRACT_IMMAT, value),
  getShowBeforePayment: (): string | null => localStorage.getItem(STORAGE_KEYS.SHOW_BEFORE_PAYMENT),
  setShowBeforePayment: (value: string) =>
    localStorage.setItem(STORAGE_KEYS.SHOW_BEFORE_PAYMENT, value),
  isFromBV: (): string | null => localStorage.getItem(STORAGE_KEYS.IS_FROM_BV),
  setIsFromBV: (value: string) => localStorage.setItem(STORAGE_KEYS.IS_FROM_BV, value),
  getIsImmatOnly: (): string | null => localStorage.getItem(STORAGE_KEYS.IS_IMMAT_ONLY),
  setIsImmatOnly: (value: string) => localStorage.setItem(STORAGE_KEYS.IS_IMMAT_ONLY, value),
  getTunnelData: (): string | null => localStorage.getItem(STORAGE_KEYS.TUNNEL_DATA),
  setTunnelData: (value: string) => localStorage.setItem(STORAGE_KEYS.TUNNEL_DATA, value),
  removeTunnelData: () => localStorage.removeItem(STORAGE_KEYS.TUNNEL_DATA),
  getSkipMyAccountOrg: (): string | null => localStorage.getItem(STORAGE_KEYS.SKIP_MY_ACCOUNT),
  setSkipMyAccountOrg: (value: string) => localStorage.setItem(STORAGE_KEYS.SKIP_MY_ACCOUNT, value),
  getCashbackReminder: (): string | null => localStorage.getItem(STORAGE_KEYS.CASHBACK_REMINDER),
  setCashbackReminder: (value: string) =>
    localStorage.setItem(STORAGE_KEYS.CASHBACK_REMINDER, value),
  removeCashbackReminder: () => localStorage.removeItem(STORAGE_KEYS.CASHBACK_REMINDER),

  /**
   * Purge toutes les données de session du navigateur (localStorage + auth_reload_retry sessionStorage).
   * Même implémentation que sur develop (4533ee702), dont dépend redirectToTunnel (#2428).
   */
  clearAllSessionData: () => {
    Object.values(STORAGE_KEYS).forEach((key) => {
      try {
        localStorage.removeItem(key);
      } catch {
        // Stockage indisponible (navigation privée stricte) : rien à purger
      }
    });
    if (typeof sessionStorage !== 'undefined') {
      try {
        sessionStorage.removeItem('auth_reload_retry');
      } catch {
        // Ignore
      }
    }
  },
};

export default AuthService;
